import { Component, OnInit } from '@angular/core';
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';

@Component({
  selector: 'app-sistemas-informatizados',
  templateUrl: './sistemas-informatizados.component.html',
  styleUrls: ['./sistemas-informatizados.component.css']
})
export class SistemasInformatizadosComponent implements OnInit {
  listaClassificacaoComponente = [];
  listaSistemasComponente = [];

  constructor(
    public service: ReclamacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService) {
  }

  ngOnInit() {
    this.preencherListaClassificacao();
    this.preencherListaSistemas();
    this.service.reclamacao.controls.descricaoReclamacao.setValue('');
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.reclamacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.value === this.service.reclamacao.value.assunto.value);
  }

  preencherListaSistemas() {
    this.listaSistemasComponente = this.service.reclamacao.value.listaSistemasCompleta;
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  checkSistemas(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaSistemasComponente, item);
    this.atribuirListaSistema();
  }

  atribuirListaClassificacao() {
    this.service.reclamacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  atribuirListaSistema() {
    this.service.reclamacao.controls.listaSistemas.setValue(this.listaSistemasComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.reclamacao.controls[str].touched &&
      this.service.reclamacao.controls[str].errors != null;
  }
}
